import NotificationsIcon from "@material-ui/icons/Notifications";
import { Bell01 as NewNotificationsIcon } from "@untitledui/icons";
import { Badge } from "@material-ui/core";
import { useRef, useState } from "react";
import { headerMenusStyles } from "../../../../_metronic/layout/_core/MaterialThemeProvider";
import { useIntl } from "../../../../_metronic/i18n/customUseIntl";
import { useNotificationContext } from "../../context/NotificationContext";
import NotificationPopover from "./NotificationPopover";

const LS_KEY = "notificationsOpen";

type NotificationsProps = {
  useNewIcon: boolean;
};

const NotificationBell = ({ useNewIcon }: NotificationsProps) => {
  const intl = useIntl();
  const commonClasses = headerMenusStyles();
  const buttonRef = useRef<HTMLDivElement>(null);
  const { notifications, isLoading, error } = useNotificationContext();

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const openPopover = () => {
    setIsPopoverOpen(true);
    localStorage.setItem(LS_KEY, "true");
  };

  const closePopover = () => {
    setIsPopoverOpen(false);
    localStorage.removeItem(LS_KEY);
  };

  const togglePopover = () => {
    if (isPopoverOpen) {
      closePopover();
    } else {
      openPopover();
    }
  };

  const unreadCount = isLoading || error ? 0 : notifications.length;

  return (
    <>
      <div
        className={(commonClasses as Record<string, string>).mainMenuItemIcon}
        onClick={togglePopover}
        ref={buttonRef}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            togglePopover();
          }
        }}
        aria-label={intl.formatMessage({ id: "NOTIFICATION.DROPDOWN.TOOLTIP" })}
        aria-expanded={isPopoverOpen}
        aria-haspopup="true"
      >
        <Badge badgeContent={unreadCount} color="error" overlap="rectangular">
          {useNewIcon ? (
            <NewNotificationsIcon fontSize="medium" width={20} height={20} />
          ) : (
            <NotificationsIcon fontSize="medium" />
          )}
        </Badge>
      </div>

      <NotificationPopover
        notifications={notifications}
        isLoading={isLoading}
        error={error}
        openPopover={isPopoverOpen}
        anchorEl={buttonRef}
        onClose={closePopover}
      />
    </>
  );
};

export default NotificationBell;
